<template>
    <el-row class="roleManage">
        <el-row class="table">
              <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>自动接单管理</span>
                    <div>
                      <el-button  type="primary" @click="addEvent">新增</el-button>
                    </div>
                  </div>
                  <div class="text item">
                    <el-table
                      v-loading="loading"
                      :data="tableData"
                      style="width: 100%">
                      <el-table-column
                        fixed
                        prop="category_name"
                        label="易价通分类">
                      </el-table-column>
                      <el-table-column
                        prop="accept_person_name"
                        label="自动接单人">
                      </el-table-column>
                      <el-table-column
                        fixed="right"
                        label="操作"
                        width="150">
                        <template slot-scope="scope">
                          <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                          <el-button @click="delateEvent(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="pages">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="pageSize"
                      @current-change="currentClick">
                    </el-pagination>
                  </div>
            </el-card>
        </el-row>
        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" @close="closeEvent">
          <el-form :model="dialogForm">
            <el-form-item label="接单人(单选)" :label-width="formLabelWidth">
              <el-cascader
                v-model="roleArr"
                clearable
                :props="{value:'id', label: 'name', children: 'children'}"
                :options="roleDatatype"
                @change="userHandleChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="亿价通分类(多选)" :label-width="formLabelWidth">
                <el-cascader
                  ref="categoryArr"
                  v-model="categoryArr"
                  :props="{value:'id', label: 'name', children: 'children',multiple: true,emitPath}"
                  :options="categoryOptions"
                  collapse-tags
                  @change="categoryChangeEvent">
                </el-cascader>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogCancel">取 消</el-button>
            <el-button type="primary" @click="dialogCommit" v-if="btnShow">新增</el-button>
            <el-button type="primary" @click="edit" v-if="!btnShow">修改</el-button>
          </div>
        </el-dialog>
    </el-row>
  </template>
  
  <script>
  import { getRole,getRoleUser,getCategoryTable,atomicAcceptInsert,acceptTable,removeAtomicAccept,atomicAcceptEdit } from '../../utils/api'
  export default {
  components: {},
  props: {},
  data() {
    return {
      total:0,
      rowId:0,
      btnShow:true,
      dialogFormVisible:false,
      formLabelWidth: '150px',
      tableData:[],
      page:1,
      pageSize:5,
      dialogForm:{
        role_id:'',     //角色id
        role_name:'',   //角色名称
        accept_person_u_u:'', //受理人unionid和userid组合
        accept_person_name:'',  //受理人名称
        category_id:[],   //部门id
        category_name:[]  //部门名称
      },
      departArr:[],
      roleArr:[],
      roleDatatype:[],
      userDatatype:[],
      categoryOptions:[],
      categoryArr:[],
      setArr:[],
      loading:false
    };
  },
  watch: {
    dialogFormVisible(value){
      if(value == false){
        this.dialogForm.role_id = '';
        this.dialogForm.role_name = '';
        this.dialogForm.category_id = [];
        this.dialogForm.category_name = []
      }
    }
  },
  computed: {},
  methods: {

    //获取角色列表
    getRoleTable(){
        var that = this
        getRole()
        .then(res=>{
            if(res.message.status == 'success'){
                console.log(res,'角色列表22222');
                that.roleDatatype = res.data
                that.userDatatype = res.data
                that.roleDatatype.forEach(item=>{
                    that.getRoleUserTable(item.id)
                })
                console.log('获取结束');
            }
        })
        .catch(err=>{
            console.log(err,'err');
        })
    },

    //获取用户列表
    getRoleUserTable(id){

        var that = this
        that.loading = true
        var params = {
            role_id:id
        }
        var arr = []
        getRoleUser(params)
        .then(res=>{
            if(res.message.status == 'success'){
                if(res.data){
                    res.data.forEach(item=>{
                      arr.push({id:item.userid,name:item.name})
                })
                }
                that.roleDatatype.forEach(item=>{
                    if(item.id == id){
                        item['children'] = arr
                    }
                })
            }else{
              that.$message.error(res.message.text)
            }
        })
        .catch(err=>{
            console.log(err,'err');
            that.$message.error(err)
        })
        that.loading = false
    },

    // 接单人(单选)change事件
    userHandleChange(e){
      this.dialogForm.role_id = this.roleArr[0];
      var params = {
        role_id:this.dialogForm.role_id
      }
      this.userDatatype.forEach(item=>{
        if(item.id == this.dialogForm.role_id){
          this.dialogForm.role_name = item.name
        }
      })
      getRoleUser(params)
      .then(res=>{
        if(res.message.status == 'success'){
          if(res.data){
            res.data.forEach(item=>{
              if(this.roleArr[1] == item.userid){
                this.dialogForm.accept_person_name = item.name
                this.dialogForm.accept_person_u_u = item.u_u
              }
            })
          }
        }else{
          this.$message.error(res.message.text)
        }
      })
    },

    // 获取所有分类列表（选项）
    getCategoryEvent(){
      getCategoryTable()
      .then(res=>{
        if(res.message.status == 'success'){
          this.categoryOptions = res.data.options
          console.log(this.categoryOptions,'this.categoryOptions');
        }else{
          this.$message.error(res.message.text)
        }
      })
    },
    // 亿价通分类(多选)change事件
    categoryChangeEvent(){
      this.dialogForm.category_id = []
      this.dialogForm.category_name = []
      this.setArr = []
      console.log(this.categoryArr,'this.categoryArr');
      this.dialogForm.category_id = this.categoryArr
      this.categoryArr.forEach(item=>{
        this.setArr.push(item[item.length-1])
      })
      this.setArr.forEach(val=>{
        this.recursion(this.categoryOptions,val)
      })
      console.log(this.dialogForm,'this.dialogForm222222222');
    },

    // 获取产品分类名称
    recursion(arr,cateId){
      arr.forEach(item=>{
        if(item.id == cateId){
          this.dialogForm.category_name.push(item.name)
        }else{
          if(item.children){
            this.recursion(item.children,cateId)
          }
        }
      })
    },

    //新增工单自动受理策略
    addEvent(){
      this.dialogFormVisible = true
      this.btnShow = true
    },

    // 工单自动受理策略列表
    getAcceptTable(){
      acceptTable()
      .then(res=>{
        console.log(res,'工单自动受理策略列表');
        if(res.message.status  == 'success'){
          this.tableData = res.data
        }else{
          this.tableData = []
          // this.$message.error(res.message.text)
          console.log(res.message.text);
        }
      })
      .catch(err=>{
        console.log(err);
      })
    },

    //删除
    delateEvent(row){
      var that = this
      var params = {
        id : row.id
      }
      removeAtomicAccept(params)
      .then(res=>{
        console.log(res,'res');
        if(res.message.status == 'success'){
          that.$message.success(res.message.text)
          that.getAcceptTable()
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
      console.log(row,'删除');
    },

    //新增工单分配自动受理
    dialogCommit(){
      var that = this
      var params = {
        role_id:that.dialogForm.role_id,
        role_name:that.dialogForm.role_name,
        accept_person_u_u:that.dialogForm.accept_person_u_u,
        accept_person_name:that.dialogForm.accept_person_name,
        category_id:JSON.stringify(that.dialogForm.category_id),
        category_name:JSON.stringify(that.dialogForm.category_name)
      }
      atomicAcceptInsert(params)
      .then(res=>{
        console.log(res,'res');
        if(res.message.status == 'success'){
          that.getAcceptTable()
          that.dialogFormVisible = false
          that.$message.success(res.message.text)
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },

    // 编辑
    editClick(row){
      console.log(row,'row');               
      this.dialogFormVisible = true
      this.btnShow = false
      this.rowId = row.id
      this.dialogForm.category_id = row.category_id
      this.dialogForm.category_name = row.category_name
      this.dialogForm.role_id = row.role_id
      this.dialogForm.role_name = row.role_name
      this.dialogForm.accept_person_u_u = row.accept_person_u_u
      this.dialogForm.accept_person_name = row.accept_person_name

      this.categoryArr = JSON.parse(row.category_id)
      var uu = row.accept_person_u_u.split('_')[1]
      this.roleArr = [row.role_id,uu]
      console.log(this.dialogForm,'this.dialogForm/////////////');
    },
    //编辑确认
    edit(){
      var that = this
      var params = {
        id:that.rowId,
        role_id:that.dialogForm.role_id,
        role_name:that.dialogForm.role_name,
        category_id:JSON.stringify(that.dialogForm.category_id),
        category_name:JSON.stringify(that.dialogForm.category_name),
        accept_person_name:that.dialogForm.accept_person_name,
        accept_person_u_u:that.dialogForm.accept_person_u_u
      }
      atomicAcceptEdit(params)
      .then(res=>{
        console.log(res,'res');
        if(res.message.status == 'success'){
          that.dialogFormVisible = false
          that.getAcceptTable()
          that.$message.success('成功')
        }else{
          that.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        console.log(err,'err');
      })
    },
    //弹窗关闭的事件
    closeEvent(){
      console.log('弹窗关闭了');
      this.setArr = []
      this.categoryArr = []
      this.roleArr = []
      this.dialogForm.role_id = ''
      this.dialogForm.role_name = ''
      this.dialogForm.accept_person_u_u = ''
      this.dialogForm.accept_person_name = ''
      this.dialogForm.category_id = []
      this.dialogForm.category_name = []
    },
    ////////////////////////////////////////////////////////////////////////

    dialogCancel(){
      console.log('弹窗取消');
      this.dialogFormVisible = false
    },
    currentClick(e){
      this.page = e
      this.getconversionTable()
      console.log('dnagqianusns');
    },

    categoryChange(e){
      var that = this
      console.log(e,'222222222');
      this.roleArr.forEach(item=>{
        if(item.id == e){
          that.dialogForm.role_name = item.name
        }
      })
    },
  },
  created() {},
  mounted() {
    this.getRoleTable()
    this.getCategoryEvent()
  },
  activated(){
    this.getAcceptTable()  //获取列表
  }
  };
  </script>
  <style lang="scss" scoped>
  .roleManage{
   .clearfix{
      display: flex;
      justify-content: space-between;
      align-items: center;
   }
   .pages{
    text-align: right;
    margin-top: 20px;
   }
  }
  </style>